export default __webpack_public_path__ + "assets/h3.0ede526e.svg";